var R;
((_) => {
  ((E) => {
    E[E.CREDIT_CARD = 1] = "CREDIT_CARD", E[E.GOOGLE_PAY = 2] = "GOOGLE_PAY", E[E.APPLE_PAY = 3] = "APPLE_PAY", E[E.BIZUM = 4] = "BIZUM", E[E.CASH = 5] = "CASH", E[E.UNKNOWN = 100] = "UNKNOWN", E[E.ADYEN_PAY_BY_BANK = 1e3] = "ADYEN_PAY_BY_BANK";
  })(_.PaymentMethodType || (_.PaymentMethodType = {})), ((E) => {
    E[E.PAYCOMET = 1] = "PAYCOMET", E[E.CHECKOUT = 2] = "CHECKOUT", E[E.STRIPE = 3] = "STRIPE", E[E.CHEERFY = 4] = "CHEERFY", E[E.ADYEN = 5] = "ADYEN", E[E.CASH = 6] = "CASH", E[E.PAY_LATER = 7] = "PAY_LATER", E[E.CASHBACK = 8] = "CASHBACK", E[E.CASHDRO = 9] = "CASHDRO", E[E.REDSYS = 10] = "REDSYS";
  })(_.PaymentMethodEngine || (_.PaymentMethodEngine = {})), ((E) => {
    E[E.CASH = 1] = "CASH", E[E.CREDIT_CARD = 2] = "CREDIT_CARD", E[E.OTHERS = 3] = "OTHERS", E[E.APPLE_WALLET = 4] = "APPLE_WALLET", E[E.LOYALTY_CASHBACK = 5] = "LOYALTY_CASHBACK", E[E.PAY_LATER = 6] = "PAY_LATER";
  })(_.TicketPaymentType || (_.TicketPaymentType = {}));
  function A(E) {
    switch (E) {
      case 1:
      case 2:
      case 4:
      case 100:
        return 2;
      case 3:
        return 4;
      case 5:
        return 1;
      default:
        return;
    }
  }
  _.convertPaymentMethodTypeToTicketPaymentType = A;
  function C(E) {
    return {
      6: "cash",
      5: "adyen",
      3: "stripe",
      1: "paycomet",
      4: "cheerfy",
      2: "checkout",
      7: "pay_later",
      8: "cashback",
      10: "redsys"
    }[E];
  }
  _.engineToString = C, ((E) => {
    E[E.UNDEFINED = 0] = "UNDEFINED", E[E.CHEERFY_WEBHOOK_POS = 1] = "CHEERFY_WEBHOOK_POS", E[E.CHEERFY_SHOP_EMBEDDED = 2] = "CHEERFY_SHOP_EMBEDDED", E[E.CHEERFY_KIOSK = 3] = "CHEERFY_KIOSK", E[E.CHEERFY_STORE_PAYMENT_METHOD = 4] = "CHEERFY_STORE_PAYMENT_METHOD", E[E.CHEERFY_EXTERNAL_SOURCE = 5] = "CHEERFY_EXTERNAL_SOURCE";
  })(_.ShopOrderSource || (_.ShopOrderSource = {})), _.THIRD_PARTY_METHODS = [
    2,
    3
    /* APPLE_PAY */
  ], _.REDIRECT_ENGINE_PARAM_ORDER_ID = "ch_payment_return_order_id", _.REDIRECT_ENGINE_PARAM_WS_ID = "ch_payment_return_ws_id", _.REDIRECT_ENGINE_PARAM_ENGINE = "ch_payment_return_engine", _.REDIRECT_ENGINES = [
    10
    /* REDSYS */
  ], _.ERROR_CODE_ORDER_ALREADY_PAID = "order_already_paid", _.NOT_ALLOWED_METHODS = [
    [
      8,
      100
      /* UNKNOWN */
    ],
    [
      void 0,
      1e3
      /* ADYEN_PAY_BY_BANK */
    ]
  ];
})(R || (R = {}));
export {
  R as PaymentAPI
};
//# sourceMappingURL=paymentApi.js.map
